import React from 'react';
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loading = () => {
    return (
        <Container>
            <Box style={{margin: 40, textAlign: 'center'}}>
                <CircularProgress color="secondary"/>
            </Box>
        </Container>
    )
};

export default Loading;
